import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { Card, CardContent } from "@mui/material";
import React, { useEffect, useState } from "react";
import LeaveDashboard from "./LeaveDashboard";
import RequestApproval from "./RequestApproval";
import AnnualLeave from "./AnnualLeave";
import TabBoxComponent from "components/UI/TabBox";

const GeneralLeave = ({
  location,
  SetSelectedMenu,
  GetAllResources,
  systemSettings,
}) => {
  const [selectedTab, setSelectedTab] = useState(location?.state?.tab ?? 0);
  const mainBackground = systemSettings?.mainBackground;

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  useEffect(() => {
    SetSelectedMenu({
      menu: "leave_mgt",
      title: " my Leaves Overview",
    });
    GetAllResources();
  }, []);

  return (
    <div className="w-full mb-12 px-4">
      <Card className="flex flex-col w-full">
        <CardContent>
          <TabBoxComponent
            selectedValue={selectedTab}
            handleTabChange={handleTabChange}
            tabList={[
              {
                label: "MY Leave Overview",
                tabValue: 0,
                permissionCode: "menu.leave_management",
              },
              {
                label: "Incoming Request",
                tabValue: 1,
                permissionCode: "submenu.leave_approval",
              },
              {
                // label: "Annual Leave",
                label: "Leave",
                tabValue: 2,
                permissionCode: "submenu.annual_leave",
              },
            ]}
          />
          <hr style={{ border: "0.5px solid #ccc", margin: "10px 0" }} />

          {selectedTab === 0 && (
            <LeaveDashboard
              location={location}
              SetSelectedMenu={SetSelectedMenu}
            />
          )}

          {selectedTab === 1 && (
            <RequestApproval
              location={location}
              SetSelectedMenu={SetSelectedMenu}
              approverId={systemSettings?.profile?.id}
            />
          )}

          {selectedTab === 2 && (
            <AnnualLeave
              location={location}
              SetSelectedMenu={SetSelectedMenu}
            />
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralLeave);
